import { render } from "./ViewAct.vue?vue&type=template&id=b47b0dda"
import script from "./ViewAct.vue?vue&type=script&lang=js"
export * from "./ViewAct.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__